

class GATArray {
    static removeFirst(items, rules) {
        for(let i = 0, len = items.length; i < len; i++) {
            if (rules(items[i])) {
                items.splice(i,1)
                return
            }
        }
    }
}

class GATExtension {
    static Array = GATArray

}

export default GATExtension